import { useLocalization } from '@fluent/react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import React, { FC } from 'react';

import { ManualIcon } from '../../icons';

const useStyles = makeStyles(() => ({
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 24,
    gap: 12,
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: 48,
      height: 48,
    },
  },
  dialogContent: {
    textAlign: 'center',
    paddingBottom: 8,
  },
  dialogActions: {
    justifyContent: 'center',
    paddingBottom: 24,
    gap: 16,
  },
}));

export interface UserManualModalProps {
  open: boolean;
  onClose: () => void;
  pdfUrl?: string;
}

const UserManualModal: FC<UserManualModalProps> = ({ open, onClose, pdfUrl }) => {
  const { l10n } = useLocalization();
  const classes = useStyles();

  const handleDownload = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="user-manual-dialog-title">
      <Box className={classes.titleBox}>
        <Box className={classes.iconWrapper}>
          <ManualIcon active />
        </Box>
        <DialogTitle id="user-manual-dialog-title">
          {l10n.getString('user-manual-title')}
        </DialogTitle>
      </Box>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>{l10n.getString('user-manual-description')}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          {l10n.getString('user-manual-cancel')}
        </Button>
        <Button onClick={handleDownload} color="primary" variant="contained">
          {l10n.getString('user-manual-download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(UserManualModal);
